import React from 'react';
import { Heading, Icon, IconNames, Text } from '@dotcom/crown-ui';
import styles from '../delete-images-confirmation-dialog.module.scss';
import { DeleteImagesDialogMessageProps } from '../delete-images-dialog-types';

export const Message = ({
  contentTitle = '',
  contentText = '',
}: DeleteImagesDialogMessageProps): React.ReactElement => {
  return (
    <div className={styles.messageContainer}>
      <Icon name={IconNames.TrashBold} size={'24'} color={'dark-gray'} />
      <Heading as="h4" color="textPrimary">
        {contentTitle}
      </Heading>

      <Text as="span">{contentText}</Text>
    </div>
  );
};
